import { BrandNewslettersType } from "@services/GACApi4/schemas/newsletterSubscription";

export const BRAND_NEWSLETTER_OPTIONS: { label: string; value: BrandNewslettersType }[] = [
  { label: "Golden Artist Acrylics", value: "golden-acrylics" },
  { label: "Williamsburg Artist Oils", value: "williamsburg-oils" },
  { label: "QoR Artist Watercolors", value: "qor-watercolors" },
  { label: "PanPastel Artist Pastels", value: "panpastel" },
];
